<template>
  <div class="exception">
    <div class="exception__img">
      <img src="https://gw.alipayobjects.com/zos/rmsportal/KpnpchXsobRgLElEozzI.svg" alt>
    </div>
    <div class="exception__content">
      <h1 class="boxcent exception__number">404</h1>
      <!-- <h2>抱歉，你访问的页面不存在</h2> -->
      <h2>Sorry, the page you visited does not exist.</h2>

      <!-- <router-link class="boxcent" :to="{name:'login'}"> -->
        <div class="boxcent">
          <a-button @click="tohome"  type="primary">Return</a-button>
        </div>
      <!-- </router-link> -->
    </div>
  </div>
</template>
<style>
.exception {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 25% 0;
  width: 100vw;
    flex-wrap: wrap;
}
h1 {
  font-size: 72px;
  color: #434e59;
  margin-bottom: 30px;
}
h2 {
  color: rgba(0, 0, 0, 0.45);
  font-size: 20px;
}
.boxcent{
  display: flex;
    align-items: center;
    justify-content: center;
}
.exception {
  display: flex;
}
.exception__img img {
  /*padding-right: 152px;*/
  height: 300px;
}
</style>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
    tohome(){
      if ("ontouchstart" in document.documentElement) {
          this.$router.push({ path: "/phone" });
        } else {
          this.$router.push({ name: "/backhome" });
        }
    }
  }
}
</script>